import * as Actions from '../../actions/termsAndConditions/types';

const initialState = {
  getTermsAndConditionsLoading: false,
  getTermsAndConditions: [],
  getTermsAndConditionsError: '',
  updateTermsAndCondLoading: false,
  updateTermsAndCond: '',
  updateTermsAndCondError: '',
};

export default function termsAndConditionsReducer(
  state = initialState,
  action,
) {
  const { type, payload } = action;

  switch (type) {
    case Actions.GET_TERMS_AND_CONDITIONS_REQUEST:
      return { ...state, getTermsAndConditionsLoading: true };

    case Actions.GET_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        getTermsAndConditionsLoading: false,
        getTermsAndConditions: payload?.data || [],
      };

    case Actions.ADD_TERMS_AND_CONDITIONS:
    case Actions.UPDATE_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        updateTermsAndCondLoading:
          type === Actions.UPDATE_TERMS_AND_CONDITIONS_SUCCESS
            ? false
            : state.updateTermsAndCondLoading,
        updateTermsAndCond:
          type === Actions.UPDATE_TERMS_AND_CONDITIONS_SUCCESS
            ? payload
            : state.updateTermsAndCond,
        getTermsAndConditions: state.getTermsAndConditions.map((item) => {
          return item.id === payload.resourceId
            ? { ...item, resourceValues: payload.data }
            : item;
        }),
      };

    case Actions.DELETE_TERMS_AND_CONDITIONS: {
      const updatedTerms = [...state.getTermsAndConditions];
      const index = updatedTerms.findIndex(
        (item) => item.id === payload.resourceId,
      );

      if (index !== -1) {
        updatedTerms[index] = {
          ...updatedTerms[index],
          resourceValues: updatedTerms[index]?.resourceValues?.filter(
            (value) => value.id !== payload.resourceValId,
          ),
        };
      }

      return {
        ...state,
        getTermsAndConditions: updatedTerms,
      };
    }

    case Actions.GET_TERMS_AND_CONDITIONS_FAIL:
      return {
        ...state,
        getTermsAndConditionsLoading: false,
        getTermsAndConditionsError: payload,
      };

    case Actions.UPDATE_TERMS_AND_CONDITIONS_REQUEST:
      return { ...state, updateTermsAndCondLoading: true };

    case Actions.UPDATE_TERMS_AND_CONDITIONS_FAIL:
      return {
        ...state,
        updateTermsAndCondLoading: false,
        updateTermsAndCondError: payload,
      };

    case Actions.CLEAR_TERMS_AND_CONDITIONS_FAIL:
      return {
        ...state,
        getTermsAndConditionsLoading: false,
        getTermsAndConditionsError: '',
        updateTermsAndCondLoading: false,
        updateTermsAndCond: '',
        updateTermsAndCondError: '',
      };

    default:
      return state;
  }
}
